import { Help } from "@mui/icons-material";
import { Box, Card, CardContent, Stack, Tooltip, Typography, useMediaQuery, useTheme } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import CustomToolbar from "../../utils/customToolbar";

function UserActicityStatusTable({ activeUserData }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));


  const columns = [
    { field: "level", headerName: "Level", flex: 1 },
    { field: "count", headerName: "Count", flex: 1 }
  ];

  return (
    <Stack direction={isMobile ? "column" : "row"} spacing={2} sx={{ mt: 4, marginRight: 2, }}>
      <Card sx={{ flex: 1, borderRadius: 3, boxShadow: 2, backgroundColor: "background.main", }}>
        <CardContent>
          {/* <Typography variant="h9" color="grey" gutterBottom marginRight={2}>
              Statistics
            </Typography> */}
          <Box display="flex" alignItems="center">
            {/* <Typography variant="h6" fontWeight="bold">
              User Activity Status
            </Typography> */}
          </Box>
          {/* <CustomBarChart
              data={activeUserData}
              layout="vertical"
              mode="multi"
              filledLabel="User Count"
            /> */}
          <div style={{ height: 317, width: "100%" }}>
            <DataGrid
              rows={activeUserData.map((item, index) => ({
                id: index + 1, // Ensure a unique ID for each row
                level: item.level,
                count: item.count,
              }))}
              columns={columns}
              pageSize={5}
              initialState={{
                  density: "compact",
              }}
              slotProps={{
                toolbar: {
                  title: "User Activity Status",
                  description: `
                Activity Levels:
                Super Active → ≥ 2 logins / 1 day
                Active → 1 login / day
                Semi-Active → 2–4 logins / 7 days
                Infrequent → ≤ 1 login / 14 days
                Dormant → Account created > 14 days ago AND 0 logins
                  `
                },
                loadingOverlay: {
                  variant: "linear-progress",
                  noRowsVariant: "skeleton",
                },
              }}
              slots={{ toolbar: CustomToolbar }}
              showToolbar
              // rowsPerPageOptions={[5]}
              hideFooterPagination
              disableRowSelectionOnClick
              sx={{
                border: "none",
                "& .MuiDataGrid-columnHeaders": {
                  backgroundColor: "rgba(0, 0, 0, 0.04)",
                  fontWeight: "bold",
                },
              }}
            />
          </div>
        </CardContent>
      </Card>
    </Stack>
  );
}

export default UserActicityStatusTable;